export const ForwardComExtractor = {
  domain: 'forward.com',

  title: {
    selectors: [
      ['meta[name="og:title"]', 'value'],
    ],
  },

  author: {
    selectors: [
      '.author-name',
      ['meta[name="sailthru.author"]', 'value'],
    ],
  },

  date_published: {
    selectors: [
      ['meta[name="date"]', 'value'],
    ],
  },

  dek: {
    selectors: [
      // enter selectors
    ],
  },

  lead_image_url: {
    selectors: [
      ['meta[name="og:image"]', 'value'],
    ],
  },

  content: {
    selectors: [
      ['.post-item-media-wrap', '.post-item p'],
    ],

    // Is there anything in the content you selected that needs transformed
    // before it's consumable content? E.g., unusual lazy loaded images
    transforms: {
    },

    // Is there anything that is in the result that shouldn't be?
    // The clean selectors will remove anything that matches from
    // the result
    clean: [
      '.donate-box',
      '.message',
      '.subtitle',
    ],
  },
};
